import { IonDate } from '../i-components/IonDate.tsx';

const CheckNotNull = Symbol('CheckNotNull');

class AuditTrail {
    public autoID: string = '';
    public initiatorID: string = '';
    public actionID: string = '';
    public details: string = '';
    public platform: string = '';
    public datetime_created: Date | null = null;

    //not in database
    public isFirstTimeLogin: boolean = false;

    constructor(
        autoID: string,
        initiatorID: string,
        actionID: string,
        details: string,
        platform: string,
        datetime_created: string,
        isFirstTimeLogin: string
    ) {
        this.autoID = this[CheckNotNull](autoID) ? autoID : '';
        this.initiatorID = this[CheckNotNull](initiatorID) ? initiatorID : '';
        this.actionID = this[CheckNotNull](actionID) ? actionID : '';
        this.details = this[CheckNotNull](details) ? details : '';
        this.platform = this[CheckNotNull](platform) ? platform : '';
        this.datetime_created = this[CheckNotNull](datetime_created) ? IonDate(datetime_created) : null;
        this.isFirstTimeLogin = this[CheckNotNull](isFirstTimeLogin) ? (isFirstTimeLogin == 'true' ? true : false) : false;
    }
    private [CheckNotNull] = (value: string) => {
        if (value && value != null && value != 'null' && value.length > 0)
            return true;
        else
            return false;
    }
}
export default AuditTrail;